<template>
  <div class="p-4 max-w-screen-sm mx-auto text-sm">
    <!-- ACTION BUTTONS -->
<div class="invoice-actions">
  <!-- BACK -->
 <button @click="$router.push({ name: 'Transaksi' })">
  ← Back
</button>
  <!-- DOWNLOAD -->
  <button class="btn-download" @click="downloadInvoiceJPG">
    ⬇ Download Invoice
  </button>
</div>
    <!-- ================= INVOICE PREVIEW (A4) ================= -->
    <div class="invoice-frame-wrapper mt-10">
      <div class="invoice-wrapper"  ref="invoicePreview">
        <!-- WATERMARK LUNAS -->
        <div class="watermark-lunas">
          LUNAS
        </div>
        <!-- ================= HEADER ================= -->
        <div class="invoice-header-grid">

          <!-- ===== ROW 1 ===== -->
          <div class="header-row top">
            <!-- LEFT : LOGO -->
            <div class="logo-box">
              <img src="../assets/img/logo/Logo.png" class="logo" />
            </div>

            <!-- RIGHT : COMPANY INFO -->
            <div class="company-info">
              <strong>Imah Kopi Croissanterie (CV Kaysen Ekaboga Makmur)</strong><br />
              Jl. Maribaya No.3, Lembang, Bandung 40391<br />
              hello@imahkopi.com<br />
              www.imahkopi.com
            </div>
          </div>

          <!-- ===== ROW 2 ===== -->
          <div class="header-row bottom">
            <!-- LEFT : OUTLET + CUSTOMER -->
            <div class="customer-info">
              <div><strong>Outlet Name:</strong></div>
              <div><span class="big-text">{{ billingName || '-' }}</span></div>
              <div><strong>Address:</strong> {{ address || '-' }}</div>
              <div><strong>Phone Number:</strong> {{ billingPhone || '-' }}</div>
              <div><strong>Customer Name:</strong> {{ receiverName || '-' }}</div>
            </div>

            <!-- RIGHT : INVOICE META -->
            <div class="invoice-meta">
              <div class="meta-row">
                <span>Invoice No</span>
                <strong>{{ invoiceNumber }}</strong>
              </div>
              <div class="meta-row">
                <span>Invoice Date</span>
                <strong>{{ formatDateID(invoiceDate) }}</strong>
              </div>
              <div class="meta-row">
                <span>Due Date</span>
                <strong>{{ formatDateID(dueDate) }}</strong>
              </div>

              <!-- TOTAL BESAR -->
              <div class="grand-total">
                <span>Rp</span>
                <strong>{{ format(grandTotal) }}</strong>
              </div>
            </div>
          </div>

        </div>


        <!-- BODY -->
        <div class="invoice-body">
          <!-- TABLE -->
          <table class="invoice-table">
            <thead>
              <tr>
                <th style="width:40px;">NO</th>
                <th>ITEM</th>
                <th class="text-right" style="width:60px;">QTY</th>
                <th class="text-right" style="width:120px;">UNIT PRICE</th>
                <th class="text-right" style="width:120px;">TOTAL</th>
              </tr>
            </thead>
            <!-- ITEMS -->
            <tbody>
              <tr v-for="(it, i) in productItems" :key="i">
                <td>{{ i + 1 }}</td>
                <td>{{ it.name }}</td>
                <td class="text-right">{{ it.quantity }}</td>
                <td class="text-right">Rp{{ format(it.price) }}</td>
                <td class="text-right">
                  Rp{{ format(it.price * it.quantity) }}
                </td>
              </tr>
            </tbody>


            <!-- SUB TOTAL -->
            <tfoot>

              <!-- Sub Total -->
              <tr class="tfoot-row subtotal">
                <td colspan="4" class="fw-bold">Sub Total<small class="qty-info"> (Total Item: {{ totalQty }})</small></td>
                <td class="text-end fw-bold">Rp{{ format(subTotal) }}</td>
              </tr>
            </tfoot>

          </table>


        <!-- ===== SUMMARY OUTSIDE TABLE ===== -->
          <div class="invoice-summary">

            <!-- DISKON INVOICE -->
            <div v-if="diskonInvoiceValue" class="summary-row">
              <span>Diskon Invoice</span>
              <span>-Rp{{ format(Math.abs(diskonInvoiceValue)) }}</span>
            </div>

            <!-- DISKON CASHBACK -->
            <div v-if="diskonValue" class="summary-row">
              <span>Lebih Deposit + Cashback</span>
              <span>-Rp{{ format(Math.abs(diskonValue)) }}</span>
            </div>
            <!-- KURANG BAYAR -->
            <div v-if="kurangBayarValue" class="summary-row">
              <span>Kurang Bayar Invoice Sebelumnya</span>
              <span>Rp{{ format(kurangBayarValue) }}</span>
            </div>
            <!-- ONGKOS -->
            <div v-if="ongkirValue" class="summary-row">
              <span>Deposit Ongkos Kirim</span>
              <span>Rp{{ format(ongkirValue) }}</span>
            </div>

            <hr />

            <!-- GRAND TOTAL -->
            <div class="summary-row summary-total">
              <span class="label">TOTAL</span>
              <span class="value">Rp{{ format(grandTotal) }}</span>
            </div>

          </div>


        </div>

       <!-- FOOTER PAYMENT BOX -->
        <div class="invoice-footer">
          <div class="payment-box">
            <div class="pay-title">PAYMENT METHOD</div>

            <div class="pay-row">
              <span>Bank:</span>
              <strong>BCA</strong>
            </div>

            <div class="pay-row">
              <span>Branch:</span>
              <strong>KCP Lembang</strong>
            </div>

            <div class="pay-row">
              <span>Account Name:</span>
              <strong>CV. Kaysen Ekaboga Makmur</strong>
            </div>

            <div class="pay-row pay-number">
              <span>Account Number:</span>
              <strong>137.88888.23</strong>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- SAVE BUTTON -->


  </div>
</template>

<script>
import html2canvas from "html2canvas";

export default {
  name: "InvoiceDownload",

  data() {
    return {
      // ==========================
      // INVOICE META
      // ==========================
      invoiceNumber: "",
      invoiceDate: "",
      dueDate: "",

      // ==========================
      // CUSTOMER INFO
      // ==========================
      billingName: "",
      billingPhone: "",
      receiverName: "",
      receiverPhone: "",
      address: "",

      // ==========================
      // ITEMS (READ ONLY)
      // ==========================
      items: [],

      // loading state
      isLoaded: false,
    };
  },

  computed: {
    // ==========================
    // DISKON INVOICE KHUSUS
    // ==========================
    diskonInvoiceValue() {
      const d = this.items.find((i) =>
        (i.name || "").toLowerCase().includes("diskon invoice")
      );

      return d
        ? (Number(d.price) || 0) * (Number(d.quantity) || 1)
        : 0;
    },
    // ==========================
    // KURANG BAYAR INVOICE
    // ==========================
    kurangBayarValue() {
      const k = this.items.find((i) =>
        (i.name || "").toLowerCase().includes("kurang bayar invoice")
      );

      return k
        ? (Number(k.price) || 0) * (Number(k.quantity) || 1)
        : 0;
    },
    // ==========================
    // ITEM PRODUK SAJA (UNTUK TABLE)
    // ==========================
    productItems() {
      return this.items.filter((i) => {
        const name = (i.name || "").toLowerCase();
        return (
          name &&
          !name.includes("diskon") &&
          !name.includes("ongkos") &&
          !name.includes("kurang bayar invoice")
        );
      });
    },

    // ==========================
    // TOTAL QTY PRODUK
    // ==========================
    totalQty() {
      return this.productItems.reduce(
        (t, i) => t + (Number(i.quantity) || 0),
        0
      );
    },

    // ==========================
    // SUBTOTAL PRODUK
    // ==========================
    subTotal() {
      return this.productItems.reduce(
        (t, i) =>
          t + (Number(i.price) || 0) * (Number(i.quantity) || 0),
        0
      );
    },

    // ==========================
    // DISKON CASHBACK BIASA
    // ==========================
    diskonValue() {
      const d = this.items.find((i) => {
        const name = (i.name || "").toLowerCase();
        return name.includes("diskon") && !name.includes("diskon invoice");
      });

      return d
        ? (Number(d.price) || 0) * (Number(d.quantity) || 1)
        : 0;
    },

    // ==========================
    // ONGKOS KIRIM
    // ==========================
    ongkirValue() {
      const o = this.items.find((i) =>
        (i.name || "").toLowerCase().includes("ongkos")
      );

      return o
        ? (Number(o.price) || 0) * (Number(o.quantity) || 1)
        : 0;
    },

    // ==========================
    // GRAND TOTAL FINAL
    // ==========================
    grandTotal() {
  return (
    this.subTotal +
    this.diskonInvoiceValue +
    this.diskonValue +
    this.kurangBayarValue + // 🔥 TAMBAH
    this.ongkirValue
  );
}
  },

  async mounted() {
    const id = this.$route.query.id;
    if (!id) return;

    await this.loadInvoice(id);
  },

  methods: {
    // ==========================
    // LOAD INVOICE DETAIL
    // ==========================
    async loadInvoice(id) {
      try {
        const res = await fetch(`/api/get_invoice_detail.php?id=${id}`);
        const json = await res.json();

        if (!json.success) {
          throw new Error("Gagal load invoice");
        }

        const inv = json.data.invoice;
        const items = json.data.items;

        // ==========================
        // META
        // ==========================
        this.invoiceNumber = inv.invoice_number || "";
        this.invoiceDate = inv.invoice_date || "";
        this.dueDate = inv.due_date || "";

        // ==========================
        // CUSTOMER
        // ==========================
        this.billingName = inv.billing_name || "";
        this.billingPhone = inv.billing_phone || "";
        this.receiverName = inv.receiver_name || "";
        this.receiverPhone = inv.receiver_phone || "";
        this.address = inv.address || "";

        // ==========================
        // ITEMS
        // ==========================
        this.items = items.map((it) => ({
          name: it.product_name,
          quantity: Number(it.quantity),
          price: Number(it.price),
        }));

        this.isLoaded = true;
      } catch (err) {
        console.error("LOAD ERROR:", err);
      }
    },

    // ==========================
    // FORMAT NUMBER
    // ==========================
    format(n) {
      return Number(n || 0).toLocaleString("id-ID");
    },

    // ==========================
    // FORMAT DATE
    // ==========================
    formatDateID(date) {
      if (!date) return "-";

      const d = new Date(date);
      return d
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "2-digit",
        })
        .replace(",", "");
    },

    // ==========================
    // DOWNLOAD JPG
    // ==========================
    async downloadInvoiceJPG() {
      const target = this.$refs.invoicePreview;
      if (!target) return;

      const canvas = await html2canvas(target, {
        backgroundColor: "#ffffff",
        scale: 2,
        useCORS: true,
        scrollY: 0,
      });

      // SAFE FILENAME
      const outlet = (this.billingName || "Outlet")
        .replace(/[^a-z0-9\s-]/gi, "")
        .trim()
        .replace(/\s+/g, " ");

      const safeInvoice = String(this.invoiceNumber || "Invoice")
        .replace(/[/\\]/g, "_")
        .replace(/\s+/g, "");

      const link = document.createElement("a");
      link.download = `${outlet}-${safeInvoice}-LUNAS.jpg`;
      link.href = canvas.toDataURL("image/jpeg", 1.0);
      link.click();
    },
  },
};
</script>



<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@200..900&display=swap');
/* ============================= */
/* FORM CONTAINER */
/* ============================= */
.invoice-form-container {
  background: #f8f9fc;
  padding: 28px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0,0,0,.04);
  font-family: "Outfit", sans-serif;
}

/* ============================= */
/* LABEL */
/* ============================= */
.form-label {
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 6px;
  color: #111;
}

/* ============================= */
/* INPUT / SELECT / TEXTAREA */
/* ============================= */
input[type="text"],
input[type="number"],
input[type="date"],
select,
textarea {
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  color: #111;
  transition: border-color .2s ease, box-shadow .2s ease;
}

/* focus */
input:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.15);
}

/* textarea */
textarea {
  min-height: 90px;
  resize: vertical;
}

/* ============================= */
/* ROW & GROUP */
/* ============================= */
.form-group {
  margin-bottom: 16px;
}

.form-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.form-row > .form-group {
  flex: 1;
  min-width: 200px;
}

/* ============================= */
/* PRODUCT ROW */
/* ============================= */
.product-row {
  display: flex;
  gap: 12px;
  margin-top: 12px;
  align-items: center;
}

.product-row input {
  max-width: 100px;
}

/* ============================= */
/* MULTISELECT */
/* ============================= */
.multiselect {
  border-radius: 10px !important;
  border-color: #d1d5db !important;
  font-size: 14px;
}

.multiselect:hover,
.multiselect:focus-within {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59,130,246,.15);
}

/* ============================= */
/* RESPONSIVE */
/* ============================= */
@media (max-width: 640px) {
  .product-row {
    flex-direction: column;
    align-items: stretch;
  }
}

/* ================= A4 CANVAS ================= */
.invoice-frame-wrapper {
  background: #fff;
  padding: 40px 0;
  display: flex;
  justify-content: center;
}

/* ================= HEADER ================= */
.invoice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  max-width: 200px;
}

.invoice-info {
  text-align: right;
  font-size: 13px;
  line-height: 1.4;
}
.btn-add {
  margin-top: 16px;
  background: #3b82f6;
  color: #fff;
  padding: 10px 18px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  border: none;
  transition: background .2s ease, transform .15s ease;
}

.btn-add:hover {
  background: #2563eb;
  transform: translateY(-1px);
}
/* ================= BILL / TITLE ================= */
.invoice-bill-logo {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label {
  font-size: 12px;
  font-weight: 600;
}

.customer-name {
  font-size: 14px;
  font-weight: 600;
  margin-top: 4px;
}

.invoice-title {
  font-size: 36px;
  font-weight: 500;
  letter-spacing: 1px;
}

/* ================= TABLE ================= */
.invoice-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 32px;
}

.invoice-table thead tr {
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
}

.invoice-table th {
  padding: 10px 6px;
  text-align: left;
  font-weight: 600;
}

.invoice-table td {
  padding: 10px 6px;
  vertical-align: top;
}

/* ================= TOTAL ================= */
.invoice-total-row {
  margin-top: 24px;
  padding-top: 12px;
  border-top: 2px solid #000;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  font-size: 15px;
  font-weight: 600;
}

/* ================= FOOTER ================= */
.invoice-footer {
  margin-top: 80px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}

.payment {
  text-align: right;
}
.save-btn {
  margin-top: 32px;
  background-color: #10b981;
  color: white;
  padding: 12px 24px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  border: none;
  cursor: pointer;
  transition: background 0.3s;
}
.invoice-header-grid {
  margin-bottom: 30px;
}

/* ===== ROW ===== */
.header-row {
  display: flex;
  justify-content: space-between;
  gap: 40px;
}

.header-row.top {
  align-items: flex-start;
  margin-bottom: 20px;
}

.header-row.bottom {
  align-items: flex-start;
}

/* ===== LOGO ===== */
.logo-box {
  width: 40%;
}

.logo {
  max-width: 100px;
}

/* ===== COMPANY INFO ===== */
.company-info {
  width: 60%;
  text-align: right;
  font-size: 13px;
  line-height: 1.4;
}

/* ===== CUSTOMER ===== */
.customer-info {
  width: 55%;
  font-size: 13px;
  line-height: 1.6;
}

/* ===== INVOICE META ===== */
.invoice-meta {
  width: 45%;
  text-align: right;
  font-size: 13px;
}

.meta-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  gap: 16px;
}

/* ===== GRAND TOTAL ===== */
.grand-total {
  margin-top: 14px;
  background: #e5e5e5;
  padding: 10px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 22px;
  font-weight: 700;
}

.grand-total span {
  font-size: 18px;
}
.btn-delete {
  background: transparent;
  border: 1px solid #ef4444;
  color: #ef4444;
  padding: 8px 14px;
  border-radius: 10px;
  font-weight: 500;
  font-size: 13px;
  transition: all .2s ease;
}

.btn-delete:hover {
  background: #ef4444;
  color: #fff;
}
.save-btn {
  margin-top: 28px;
  width: 100%;
  background: #111827;
  color: #fff;
  padding: 14px 0;
  border-radius: 14px;
  font-weight: 700;
  font-size: 15px;
  border: none;
  transition: background .2s ease, transform .15s ease;
}

.save-btn:hover {
  background: #000;
  transform: translateY(-1px);
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;               /* jarak label ↔ input */
  margin-bottom: 16px;
}
.form-label {
  display: block;
  font-weight: 600;
  font-size: 13px;
  color: #111;
  line-height: 1.3;
}
.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
}
.form-group {
  position: relative;
}
.suggestion-list {
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  margin-top: 6px;
}
.suggestion-list li {
  padding: 10px 12px;
  cursor: pointer;
  transition: background .2s ease;
}
.form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.form-row .form-group {
  flex: 1;
  min-width: 220px;
}
@media (max-width: 640px) {
  .form-row {
    flex-direction: column;
  }
}
.form-input,
.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  color: #111;
  transition: border-color .2s ease, box-shadow .2s ease;
}

/* Focus state */
.form-input:focus,
.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.15);
}
.invoice-summary {
  margin-top: 14px;
  margin-left: auto;
  width: 100%;
  max-width: 100%;
}

.invoice-summary .summary-row {
  display: grid;
  grid-template-columns: 1fr 120px; /* 🔥 SAMA DENGAN KOLOM TOTAL */
  align-items: center;
  margin-bottom: 6px;
}

.invoice-summary .summary-row span:last-child {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.summary-divider {
  border-top: 2px solid #000;
  margin: 12px 0;
}

.invoice-wrapper {
  width: 794px;
  min-height: 1123px;      /* A4 HEIGHT */
  padding: 48px 56px;
  background: #fff;
  color: #111;
  font-family: "Outfit", sans-serif;
  font-size: 13px;
  border: 1px solid #000;

  /* 🔥 INI KUNCI */
  display: flex;
  flex-direction: column;
}
.invoice-footer {
  margin-top: auto;       /* 🔥 PUSH KE BAWAH */
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  padding-top: 24px;
}
.invoice-body {
  margin-top: 24px;
}
.invoice-table tfoot tr {
  border-top: 2px solid #000;
}

.subtotal-row td {
  font-weight: 700;
  padding-top: 12px;
}
.invoice-summary {
  margin-top: 14px;
  max-width: 360px;
  margin-left: auto;
  font-size: 13px;
}

.invoice-summary .row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}
.invoice-summary {
  margin-top: 12px;
  width: 360px;          /* sejajar TOTAL */
  margin-left: auto;    /* dorong ke kanan */
  font-size: 13px;
}

.invoice-summary {
  margin-top: 14px;
  width: 360px;        /* samakan dengan kolom TOTAL tabel */
  margin-left: auto;
  font-size: 13px;
}

/* SEMUA ROW SUMMARY */
.summary-row {
  display: grid;
  grid-template-columns: 1fr 120px; /* 🔥 120px = TOTAL column */
  align-items: center;
  margin-bottom: 6px;
}

/* LABEL KIRI */
.summary-row .label {
  text-align: left;
}

/* VALUE KANAN (ANGKA) */
.summary-row .value {
  text-align: right;
  font-variant-numeric: tabular-nums;
}


.invoice-table tfoot .tfoot-row td {
  padding: 10px 6px;
}

.invoice-table tfoot .subtotal td {
  font-size: 14px;
}

.invoice-table tfoot .grand td {
  font-size: 40px;
  font-weight: 700;
}

.invoice-table tfoot .tfoot-sep td {
  padding: 8px 0;
  border-top: 2px solid #000;
}
.text-right {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.invoice-table th.text-right,
.invoice-table td.text-right {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
/* WRAPPER SUMMARY */
.invoice-summary {
  margin-top: 14px;
  width: 360px;          /* FIX – sejajar kolom TOTAL tabel */
  margin-left: auto;
  font-size: 13px;
}

/* ROW DEFAULT */
.summary-row {
  display: grid;
  grid-template-columns: 1fr 120px; /* 🔥 120px = kolom TOTAL */
  align-items: center;
  margin-bottom: 6px;
}

/* LABEL KIRI */
.summary-row .label {
  text-align: left;
}

/* VALUE KANAN */
.summary-row .value {
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;  /* 🔥 CEGAH KELUAR CONTAINER */
}

/* ===== TOTAL FINAL ===== */
.summary-total {
  margin-top: 12px;
  padding-top: 12px;
  /* border-top: 2px solid #000; */
}

.summary-total .label,
.summary-total .value {
  font-size: 20px;
  font-weight: 700;
}
.invoice-footer {
  margin-top: 70px;
  display: flex;
  justify-content: center;
}

/* PAYMENT BOX */
.payment-box {
  border: 2px solid #000;
  padding: 18px 26px;
  border-radius: 14px;
  text-align: center;
  width: 100%;
  max-width: 420px;
}

/* TITLE */
.pay-title {
  font-size: 16px;
  font-weight: 800;
  margin-bottom: 14px;
  text-transform: uppercase;
}

/* ROWS */
.pay-row {
  font-size: 14px;
  margin-bottom: 6px;
  display: flex;
  justify-content: space-between;
}

/* ACCOUNT NUMBER HIGHLIGHT */
.pay-number {
  margin-top: 12px;
  font-size: 18px;
  font-weight: 900;
}
.invoice-footer{
  margin-top: auto;        /* 🔥 ini kuncinya */
  display: flex;
  justify-content: center;
  padding-top: 18px;
}
.invoice-table tbody td:first-child {
  border-right: 2px solid #000;
}

.invoice-table thead th:first-child {
  border-right: 2px solid #000;
}
.locked {
  background: #f3f4f6;
  color: #6b7280;
  cursor: not-allowed;
}
.big-text{
  font-size: 30px !important;
  margin-top: -15px;
}
.invoice-actions {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.invoice-actions button {
  padding: 10px 18px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  border: none;
  cursor: pointer;
  transition: 0.2s;
}

/* BACK */
.btn-back {
  background: #e5e7eb;
  color: #111;
}

.btn-back:hover {
  background: #d1d5db;
}

/* DOWNLOAD */
.btn-download {
  background: #111827;
  color: white;
}

.btn-download:hover {
  background: black;
}
.watermark-lunas {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-25deg);
  font-size: 140px;
  font-weight: 900;
  color: rgba(255, 0, 0, 0.15);
  z-index: 10;
  pointer-events: none;
  user-select: none;
}

.invoice-wrapper {
  position: relative;
}

</style>
